var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-scroll',{ref:"vs",staticClass:"scroll-bar",attrs:{"ops":_vm.ops},on:{"handle-scroll":_vm.handleScroll}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }